import type { SetupStatusItemKey } from '@/types/setup-status'

export interface GuideRegistryEntry {
  /** Ruta Wouter a la que navegar al lanzar la guía. */
  route: string
  /**
   * Identificador único de la guía — coincide con lo que pasa usePendingGuide.
   * Opcional: si no está presente, launchGuide solo navega, sin arrancar ningún tour.
   */
  guideId?: string
  /** Texto del botón en el panel de primeros pasos. */
  label: string
}

/**
 * Registro de guías disponibles por clave de SetupStatus.
 * Solo se pueblan las claves que tienen una guía implementada.
 * Las demás no reciben botón "Abrir guía" en el panel.
 *
 * Este registro es sólo la puerta de entrada DESDE los primeros pasos. Una guía
 * que no figura acá sigue existiendo y arrancando en su propia pantalla — es el
 * caso de `guide-contratos`, que se lanza al entrar a /comercial/contratos.
 */
export const GUIDE_REGISTRY: Partial<Record<SetupStatusItemKey, GuideRegistryEntry>> = {
  al_menos_un_cargo_custom: {
    route: '/personas/cargos',
    guideId: 'guide-cargos',
    label: 'Abrir guía',
  },
  al_menos_un_trabajador_extra: {
    route: '/personas/trabajadores',
    guideId: 'guide-trabajadores',
    label: 'Ver guía',
  },
  al_menos_un_area_real: {
    route: '/personas/areas',
    guideId: 'guide-areas',
    label: 'Ver guía',
  },
  al_menos_un_epp_personalizado: {
    route: '/recursos/epp',
    guideId: 'guide-epp',
    label: 'Ver guía',
  },
  al_menos_un_vehiculo: {
    route: '/recursos/vehiculos',
    guideId: 'guide-vehiculos',
    label: 'Ver guía',
  },
  al_menos_una_maquinaria: {
    route: '/recursos/maquinaria',
    guideId: 'guide-maquinaria',
    label: 'Ver guía',
  },
  empresa_datos_completos: {
    route: '/configuracion/empresa',
    guideId: 'guide-empresa',
    label: 'Ver guía',
  },
  al_menos_un_documento_empresa: {
    route: '/configuracion/capacitaciones',
    guideId: 'guide-capacitaciones',
    label: 'Ver guía',
  },
  // El cargo propio se consulta en el perfil, no en Trabajadores: el dueño
  // no se administra a sí mismo desde el listado de su dotación.
  owner_cargo_asignado: {
    route: '/usuario/perfil',
    guideId: 'guide-perfil',
    label: 'Ver guía',
  },
}
